import type { Category } from '@twisto/api-cms'
import { Flex } from '@twisto/components/atoms/flex'
import { Link } from '@twisto/components/atoms/link'
import { Typography } from '@twisto/components/atoms/typography'

import { CategoryIcon } from '../../category-box'

import * as styles from './section-header.styles'

type Props = {
  to?: string
  icon?: Category['icon']
  name?: string
}

export const SectionHeader = ({ to, icon, name }: Props) => (
  <Link color="main" to={to}>
    <Flex alignItems="center" component="header" css={styles.header}>
      <CategoryIcon css={styles.icon} icon={icon} />
      <Typography component="h3" fontWeight="heavy" variant="h3">
        {name}
      </Typography>
    </Flex>
  </Link>
)
